/* eslint-disable no-unused-expressions */
/* eslint-disable no-restricted-syntax */
import React, { useContext, useRef } from "react";
import PropTypes from "prop-types";
import styles from "./mega-item.module.scss";
import Item from "../items/item";
import Toplist from "~molecules/toplist/header";
import { Context } from "~context/MainProvider.js";
import { getPositionClass } from "~helpers/menu";
import { TrackingKeys } from '~constants/tracking-api'
import { isMobileDevice } from "~helpers/device-detect";

// Test included with menu molecule test
const Items = ({ item, gtmClass = "", level = 1, toplist }) => {
  const link = <Item item={item} gtmClass={gtmClass} />;
  const subMenuListRef = useRef(null);
  const megaItemRef = useRef(null);
  const parentMenuRef = useRef(null);
  const { admin } = useContext(Context) || {};

  const onClick = () => {
    subMenuListRef.current.classList.toggle(styles.show);
    megaItemRef.current.classList.toggle(styles.show);
  };

  return (
    <li
      ref={parentMenuRef}
      className={`${styles.menuItem || ""} ${
        styles[`level${level.toString()}`] || ""
      } 
      ${item.children !== undefined ? styles.hasChildren || "" : ""} 
      `}
      onFocus={(e) => getPositionClass(e.target, styles)}
      onMouseOver={(e) => getPositionClass(e.target, styles)}
      role="menuitem"
      tabIndex="0"
      onKeyDown={(e) => {
        if (isMobileDevice()) {
          if (e.target.tagName.toLowerCase() !== "a") {
            if (e.defaultPrevented) return;
            e.preventDefault();
            onClick(e);
          }
        }
      }}
      onClick={(e) => {
        if (isMobileDevice()) {
          if (e.target.tagName.toLowerCase() !== "a") {
            if (e.defaultPrevented) return;
            e.preventDefault();
            onClick(e);
          }
        }
      }}
    >
      {link}
      {item.children && (
        <div
          ref={megaItemRef}
          className={`${styles.subMenuList || ""} ${
            admin && styles.adminPresent || ''
          }`}
        >
          <div className={styles.megaContainer}>
            <ul ref={subMenuListRef} className={`${styles.megaItems}`}>
              {item.children.map((child) => (
                <li className={`${styles.level2 || ""}`}>
                  <Item item={child} gtmClass={gtmClass} />
                </li>
              ))}
            </ul>

            {toplist && <Toplist module={toplist} limit={4} moduleName={TrackingKeys?.NAVIGATIONTOPLIST} />}
          </div>
        </div>
      )}
    </li>
  );
};

Items.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string,
    value: PropTypes.string,
    children: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        value: PropTypes.string,
      })
    ),
  }).isRequired,
  gtmClass: PropTypes.string,
  level: PropTypes.number,
  toplist: PropTypes.shape({}),
};

export default Items;
